import React, { useContext, useState } from "react";
import { ContentContext } from "../contexts/ContentContext";
import { FiMail } from "react-icons/fi";

export default function NewsletterSignup({ compact = false }) {
    const { data } = useContext(ContentContext);
    const n = data.newsletter;
    const [email, setEmail] = useState("");
    const [done, setDone] = useState(false);
    if (!n) return null;

    const submit = (e) => {
        e.preventDefault();
        // Wire to Mailchimp / Brevo / etc. later. For now, optimistic UI.
        setDone(true);
        setEmail("");
    };

    return (
        <div className={compact ? "" : "bg-white border border-navy-100 rounded-2xl p-6 md:p-8"}>
            {!compact && (
                <>
                    <h3 className="font-serif text-xl md:text-2xl font-bold text-navy-900 mb-2">
                        {n.title}
                    </h3>
                    <p className="text-sm text-navy-700/85 mb-4">{n.subtitle}</p>
                </>
            )}
            <form onSubmit={submit} className="flex flex-col sm:flex-row gap-2">
                <label className="sr-only" htmlFor="ns-newsletter-email">
                    {n.placeholder}
                </label>
                <div className="relative flex-1">
                    <FiMail className="absolute left-3 top-1/2 -translate-y-1/2 text-navy-500" />
                    <input
                        id="ns-newsletter-email"
                        type="email"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={n.placeholder}
                        className="w-full pl-10 pr-4 py-3 rounded-lg border border-navy-200 bg-white focus:border-gold-400 focus:ring-2 focus:ring-gold-100 outline-none transition text-sm"
                    />
                </div>
                <button
                    type="submit"
                    className="px-5 py-3 rounded-lg gradient-emerald text-white font-semibold text-sm shadow-soft hover:shadow-glow hover:brightness-110 transition"
                >
                    {n.button}
                </button>
            </form>
            {done && (
                <div role="status" className="mt-3 text-sm text-brand-emerald font-semibold">
                    Subscribed — thank you.
                </div>
            )}
        </div>
    );
}
